import suscripcionesApi from '@/api/suscripciones'

export default {
    namespaced: true,
    state: {
        modulos: [],
        features: [],
        planes: [],
        suscripciones: [],
        servicios: [],
        cuentaEmpresas: [],
        resumenes: [],
        resumenActual: null,
        loading: false,
        error: null,
    },
    mutations: {
        SET_MODULOS(state, modulos) {
            state.modulos = modulos
        },
        SET_FEATURES(state, features) {
            state.features = features
        },
        SET_PLANES(state, planes) {
            state.planes = planes
        },
        SET_SUSCRIPCIONES(state, suscripciones) {
            state.suscripciones = suscripciones
        },
        SET_LOADING(state, bool) {
            state.loading = bool
        },
        SET_ERROR(state, error) {
            state.error = error
        },
        ADD_PLAN(state, plan) {
            state.planes.push(plan)
        },
        UPDATE_PLAN(state, plan) {
            const idx = state.planes.findIndex(p => p.id === plan.id)
            if (idx !== -1) state.planes.splice(idx, 1, plan)
        },
        REMOVE_PLAN(state, id) {
            state.planes = state.planes.filter(p => p.id !== id)
        },
        ADD_SUSCRIPCION(state, suscripcion) {
            state.suscripciones.push(suscripcion)
        },
        UPDATE_SUSCRIPCION(state, suscripcion) {
            const idx = state.suscripciones.findIndex(s => s.id === suscripcion.id)
            if (idx !== -1) state.suscripciones.splice(idx, 1, suscripcion)
        },
        REMOVE_SUSCRIPCION(state, id) {
            state.suscripciones = state.suscripciones.filter(s => s.id !== id)
        },
        SET_SERVICIOS(state, servicios) {
            state.servicios = servicios
        },
        SET_CUENTA_EMPRESAS(state, cuenta) {
            state.cuentaEmpresas = cuenta
        },
        SET_RESUMENES(state, resumenes) {
            state.resumenes = resumenes
        },
        SET_RESUMEN_ACTUAL(state, resumen) {
            state.resumenActual = resumen
        },
    },
    actions: {
        async fetchModulos({ commit }) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getModulos()
                commit('SET_MODULOS', response.data)
            } catch (e) {
                commit('SET_ERROR', e)
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async fetchFeatures({ commit }) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getFeatures()
                commit('SET_FEATURES', response.data)
            } catch (e) {
                commit('SET_ERROR', e)
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async fetchPlanes({ commit }) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getPlanes()
                commit('SET_PLANES', response.data)
            } catch (e) {
                commit('SET_ERROR', e)
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async createPlan({ commit }, data) {
            const response = await suscripcionesApi.createPlan(data)
            commit('ADD_PLAN', response.data)
            return response.data
        },
        async updatePlan({ commit }, { id, data }) {
            const response = await suscripcionesApi.updatePlan(id, data)
            commit('UPDATE_PLAN', response.data)
            return response.data
        },
        async deletePlan({ commit }, id) {
            await suscripcionesApi.deletePlan(id)
            commit('REMOVE_PLAN', id)
        },
        async fetchSuscripciones({ commit }) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getSuscripciones()
                commit('SET_SUSCRIPCIONES', response.data)
            } catch (e) {
                commit('SET_ERROR', e)
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async createSuscripcion({ commit }, data) {
            const response = await suscripcionesApi.createSuscripcion(data)
            commit('ADD_SUSCRIPCION', response.data)
            return response.data
        },
        async updateSuscripcion({ commit }, { id, data }) {
            const response = await suscripcionesApi.updateSuscripcion(id, data)
            commit('UPDATE_SUSCRIPCION', response.data)
            return response.data
        },
        async deleteSuscripcion({ commit }, id) {
            await suscripcionesApi.deleteSuscripcion(id)
            commit('REMOVE_SUSCRIPCION', id)
        },

        // ─── Facturación del SaaS ──────────────────────────────────────────

        async fetchServicios({ commit }) {
            const response = await suscripcionesApi.getServicios()
            commit('SET_SERVICIOS', response.data)
            return response.data
        },
        async createServicio(_, data) {
            const response = await suscripcionesApi.createServicio(data)
            return response.data
        },
        async fetchCuentaEmpresas({ commit }) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getCuentaEmpresas()
                commit('SET_CUENTA_EMPRESAS', response.data)
            } catch (e) {
                commit('SET_ERROR', e)
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async fetchResumenes({ commit }, params = {}) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getResumenes(params)
                commit('SET_RESUMENES', response.data)
                return response.data
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async fetchResumen({ commit }, id) {
            commit('SET_LOADING', true)
            try {
                const response = await suscripcionesApi.getResumen(id)
                commit('SET_RESUMEN_ACTUAL', response.data)
                return response.data
            } finally {
                commit('SET_LOADING', false)
            }
        },
        async generarResumenes(_, data) {
            const response = await suscripcionesApi.generarResumenes(data)
            return response.data
        },
        async emitirResumen({ commit }, { id, data = {} }) {
            const response = await suscripcionesApi.emitirResumen(id, data)
            commit('SET_RESUMEN_ACTUAL', response.data)
            return response.data
        },
        async anularResumen({ commit }, id) {
            const response = await suscripcionesApi.anularResumen(id)
            commit('SET_RESUMEN_ACTUAL', response.data)
            return response.data
        },
        async reabrirResumen({ commit }, id) {
            const response = await suscripcionesApi.reabrirResumen(id)
            commit('SET_RESUMEN_ACTUAL', response.data)
            return response.data
        },
        async pagarResumen({ commit }, { id, data }) {
            const response = await suscripcionesApi.pagarResumen(id, data)
            commit('SET_RESUMEN_ACTUAL', response.data)
            return response.data
        },
        async agregarLinea(_, data) {
            const response = await suscripcionesApi.createLinea(data)
            return response.data
        },
        async eliminarLinea(_, id) {
            await suscripcionesApi.deleteLinea(id)
        },
        async editarPago(_, { id, data }) {
            const response = await suscripcionesApi.updatePago(id, data)
            return response.data
        },
        async anularPago(_, { id, motivo }) {
            const response = await suscripcionesApi.anularPago(id, motivo)
            return response.data
        },
        async deleteResumen(_, id) {
            await suscripcionesApi.deleteResumen(id)
        },
    },
    getters: {
        modulosCodigos: state => state.modulos.map(m => m.codigo),
    },
}
